<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home" [text]="'core.backButton' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>Details</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-item lines="full" class="ion-text-center">
    @if (dish.counter) {
      <ion-label>
        <img src="assets/canteen/categories/{{ dish.category }}.svg" (error)="hideImage($event)" class="title-image" />
        <span class="title">{{ dish.counter }}</span>
      </ion-label>
    }
    @else {
      <ion-label class="title">
        {{ "canteen.counterNotAvailable" | translate }}
      </ion-label>
    }
  </ion-item>
  <ion-item lines="none">
    <ion-label class="ion-text-wrap">
      {{ canteenService.getLocalizedString(dish.title) }}
      <p class="pictograms">
        @for (type of dish.type; track type) {
          <span>
            @if (canteenService.getPictogram(type)) {
              <img class="type" height="20px" role="img" [alt]="type" [src]="canteenService.getPictogram(type)" />
            }
          </span>
        }
      </p>
    </ion-label>
  </ion-item>
  @if (additives) {
    <ion-item>
      <ion-label>
        <b>{{ 'canteen.information.additives' | translate }}</b>
      </ion-label>
    </ion-item>
  }
  @if (additives) {
    <ion-grid>
      @for (additive of getNamedAdditives(); track additive) {
        <ion-row>
          <ion-col size="2">
            <b>{{ additive.id }}</b>
          </ion-col>
          <ion-col>
            {{ additive.name }}
          </ion-col>
        </ion-row>
      }
    </ion-grid>
  }
  @if (dish.price.student !== '0,00 €' && dish.price.staff !== '0,00 €' && dish.price.guest !== '0,00 €') {
    <ion-item>
      <ion-label>
        <b>{{ 'canteen.prices' | translate }}</b>
      </ion-label>
    </ion-item>
  }
  <ion-grid class="ion-text-center">
    <ion-row class="ion-text-center">
      @if (dish.price.student !== '0,00 €') {
        <ion-col>
          <b>{{ 'canteen.price.students' | translate }}</b>
        </ion-col>
      }
      @if (dish.price.staff !== '0,00 €') {
        <ion-col>
          <b>{{ 'canteen.price.employees' | translate }}</b>
        </ion-col>
      }
      @if (dish.price.guest !== '0,00 €') {
        <ion-col>
          <b>{{ 'canteen.price.guests' | translate }}</b>
        </ion-col>
      }
    </ion-row>
    <ion-row>
      @if (dish.price.student !== '0,00 €') {
        <ion-col>
          {{ dish.price.student }}
        </ion-col>
      }
      @if (dish.price.staff !== '0,00 €') {
        <ion-col>
          {{ dish.price.staff }}
        </ion-col>
      }
      @if (dish.price.guest !== '0,00 €') {
        <ion-col>
          {{ dish.price.guest }}
        </ion-col>
      }
    </ion-row>
  </ion-grid>
</ion-content>
